import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { SystemConfigurationService } from '../service/system-configuration.service';

export const maintenanceGuard: CanActivateFn = () => {
  const config = inject(SystemConfigurationService);
  const router = inject(Router);

  if (config.isMaintenanceMode) {
    router.navigate(['/mantenimiento']).then();
    return false;
  }
  return true;
};
